import { IActionResultSectionProps } from "components/actions-common/action-result-section/action-result-section.props";
import { ITableColumn } from "@interfaces/common.interfaces";
import ActionResultSection from "components/actions-common/action-result-section/action-result-section";

const cols: Array<ITableColumn<any>> = [
    { key: "itemName", label: "Item Name", showInGrid: true, showInExport: true, minWidth: 200 },
    { key: "linkUrl", label: "Link URL", showInGrid: true, showInExport: true, minWidth: 300 },
    { key: "workspaceName", label: "Workspace", showInGrid: true, showInExport: true, minWidth: 200 },
    { key: "removed", label: "Removed", showInGrid: true, showInExport: true, minWidth: 100 },
];

export default function RemoveSharingLinksAction() {

    const sectionProps: IActionResultSectionProps<any> = {
        columns: cols,
    }

    return (
        <ActionResultSection {...sectionProps} />
    );
}